import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { getUser, hasPermission } from "./session";
import { homePathForRole } from "./homePath";

/**
 * Gate a route by permissions (any-of) and/or roles.
 *
 * When both `permissions` and `roles` are provided, the user must satisfy
 * at least one role AND at least one permission (AND semantics between sets).
 * When only one is provided, only that set is checked.
 */
export function RequirePermission({
  permissions,
  roles,
  children,
}: {
  permissions?: string[];
  roles?: string[];
  children: ReactNode;
}) {
  const user = getUser();
  const role = user?.role;

  if (roles && roles.length > 0) {
    if (!role || !roles.includes(role)) {
      return <Navigate to={homePathForRole(role)} replace />;
    }
  }

  if (permissions && permissions.length > 0) {
    const hasPerm = permissions.some((p) => hasPermission(user, p));
    if (!hasPerm) {
      return <Navigate to={homePathForRole(role)} replace />;
    }
  }

  return <>{children}</>;
}
